import { borrowerCitizenshipTypeOptions } from "./select-options";

// "Foreign National" is a portal-only citizenship choice (citizenshipTypeOptions). Encompass
// has no such residency type, so the wizard sends it as NonPermanentResidentAlien and records
// the real answer in CX.FOREIGNNATLBORR1-6 / CX.FOREIGNNATL / CX.CITIZENSHIP. Same logic as
// edit-loan-application/index.jsx:825-864 and create-loan-application/index.jsx:470-509.

export const FOREIGN_NATIONAL = "Foreign National";
export const MAX_BORROWER_SLOTS = 6; // 3 pairs × (borrower + co-borrower)

export const FOREIGN_NATIONAL_FIELD_IDS = [
	...Array.from({ length: MAX_BORROWER_SLOTS }, (_, i) => `CX.FOREIGNNATLBORR${i + 1}`),
	"CX.FOREIGNNATL",
	"CX.CITIZENSHIP",
];

/** Encompass-safe residency type for a portal citizenship value. */
export const toEncompassCitizenship = (citizenship) =>
	citizenship === FOREIGN_NATIONAL ? "NonPermanentResidentAlien" : citizenship || "";

/**
 * @param {string[]} citizenships portal citizenship per borrower slot, index 0..5
 *   (even = borrower, odd = co-borrower of pair index/2)
 * @returns {{id: string, value: string}[]} field values for useUpdateFieldsMutation
 */
export const buildForeignNationalFieldValues = (citizenships) => {
	const values = [];
	let hasForeignNational = "No";
	for (let index = 0; index < MAX_BORROWER_SLOTS; index++) {
		const value = citizenships?.[index] === FOREIGN_NATIONAL ? "Yes" : "No";
		if (value === "Yes") hasForeignNational = "Yes";
		values.push({ id: `CX.FOREIGNNATLBORR${index + 1}`, value });
	}
	values.push({ id: "CX.FOREIGNNATL", value: hasForeignNational });

	const first = citizenships?.[0];
	values.push({
		id: "CX.CITIZENSHIP",
		value:
			first === FOREIGN_NATIONAL
				? FOREIGN_NATIONAL
				: borrowerCitizenshipTypeOptions.find((o) => o.value === first)?.label || "",
	});
	return values;
};

/** Slot indexes (0..5) that Encompass flags as foreign national, from a field() response. */
export const foreignNationalSlotsFromFields = (fieldsResponse) => {
	const slots = new Set();
	(fieldsResponse || []).forEach((f) => {
		const match = /^CX\.FOREIGNNATLBORR(\d)$/.exec(f?.fieldId || "");
		if (match && f.value === "Yes") slots.add(Number(match[1]) - 1);
	});
	return slots;
};
